import { env } from '../../../../configs/env';
import { UrlService } from '../../../../core/services/UrlService';

const imgDir = 'campaigns/goldeneyecare';
const href = 'campaigns/goldeneyecare';

export const config = {
    layoutSettings: {
        // launchDate: undefined,
        // requirePassword: 'test',
        // endDate: new Date('2022-06-21'),
        removeNav: true,
        removeFooter: true,
    },
    images: {
        banner: {
            subsidy: UrlService.getLocalImageUrl(`${imgDir}/banner-subsidy-mobile.png`),
            subsidyStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/banner-subsidy-mobile.png`),
        },
        icon: {
            activity: UrlService.getLocalImageUrl(`${imgDir}/activity.png`),
            content: UrlService.getLocalImageUrl(`${imgDir}/content.png`),
            introduction: UrlService.getLocalImageUrl(`${imgDir}/introduction.png`),
            sponsor: UrlService.getLocalImageUrl(`${imgDir}/sponsor.png`),
        },
        eventLogo: UrlService.getLocalImageUrl(`${imgDir}/logo.png`),
        finddocLogo: UrlService.getLocalImageUrl(`logo/logo.png`),
        finddoc3xLogo: UrlService.getLocalImageUrl(`logo/logo3x.png`),
        bayerLogo: UrlService.getLocalImageUrl(`${imgDir}/bayer-logo.png`),
        gafLogo: UrlService.getLocalImageUrl(`${imgDir}/gaf-logo.png`),
        gafLogoH: UrlService.getLocalImageUrl(`${imgDir}/gaf-logo-h.png`),
        whatsappFloatingButton: UrlService.getLocalImageUrl(`${imgDir}/whatsapp-floating-button.png`),
        common: {
            cloud: UrlService.getLocalImageUrl(`${imgDir}/common-cloud.png`),
            heroBackgroundStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/common-hero-background.png`),
        },
        selftest: {
            heroForm: UrlService.getLocalImageUrl(`${imgDir}/selftest-hero-form.png`),
            heroBackgroundStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/selftest-hero-background.png`),
            backgroundStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/selftest-background.png`),
        },
        selftestresult: {
            heroBackgroundStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/result-background.png`),
            atRisk: UrlService.getLocalImageUrl(`${imgDir}/result-0.png`),
            severe: UrlService.getLocalImageUrl(`${imgDir}/result-1.png`),
            medium: UrlService.getLocalImageUrl(`${imgDir}/result-2.png`),
            mild: UrlService.getLocalImageUrl(`${imgDir}/result-3.png`),
            noRisk: UrlService.getLocalImageUrl(`${imgDir}/result-4.png`),
        },
        home: {
            heroBackgroundStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/background.png`),
            titleText: UrlService.getLocalImageUrl(`${imgDir}/home-title-text.png?1`),
            family: UrlService.getLocalImageUrl(`${imgDir}/home-family.png`),
            topRightLeaf: UrlService.getLocalImageUrl(`${imgDir}/home-top-leaf.png`),
            topLeftLeaf: UrlService.getLocalImageUrl(`${imgDir}/home-top-left-leaf.png`),
            mobileBanner: UrlService.getLocalImageUrl(`${imgDir}/banner-mobile.png`),
            // grid3: UrlService.getLocalImageUrl(`${imgDir}/home-grid-3.png`),
        },
        sponsor: {
            heroBackgroundStyle: UrlService.getLocalImageUrlStyle(`${imgDir}/background-subsidy.png`),
        },
        content: {
            computer: UrlService.getLocalImageUrl(`${imgDir}/content-computer.png`),
            readingPeople: UrlService.getLocalImageUrl(`${imgDir}/content-people-reading.png`),
        },
        intro: {
            paragraph1Image: UrlService.getLocalImageUrl(`${imgDir}/paragraph-1.png`),
            paragraph2Image: UrlService.getLocalImageUrl(`${imgDir}/paragraph-2.png`),
            man: UrlService.getLocalImageUrl(`${imgDir}/intro-hero-man.png`),
            woman: UrlService.getLocalImageUrl(`${imgDir}/intro-hero-woman.png`),
            section1: UrlService.getLocalImageUrl(`${imgDir}/intro-section-1.png`),
            section2: UrlService.getLocalImageUrl(`${imgDir}/intro-section-2.png`),
            section3Grid1: UrlService.getLocalImageUrl(`${imgDir}/intro-section-3-grid-1.png`),
            section3Grid2: UrlService.getLocalImageUrl(`${imgDir}/intro-section-3-grid-2.png`),
            section3Grid3: UrlService.getLocalImageUrl(`${imgDir}/intro-section-3-grid-3.png`),
            section3Grid4: UrlService.getLocalImageUrl(`${imgDir}/intro-section-3-grid-4.png`),
            section4: UrlService.getLocalImageUrl(`${imgDir}/intro-section-4.png`),
        },
        cure: {
            section1Grid1: UrlService.getLocalImageUrl(`${imgDir}/cure-section-1-grid-1.png`),
            section1Grid2: UrlService.getLocalImageUrl(`${imgDir}/cure-section-1-grid-2.png`),
            section2: UrlService.getLocalImageUrl(`${imgDir}/cure-section-2.png`),
            section3: UrlService.getLocalImageUrl(`${imgDir}/cure-section-3.png`),
            section4: UrlService.getLocalImageUrl(`${imgDir}/cure-section-4.png`),
        },
        questions: {
            section1: UrlService.getLocalImageUrl(`${imgDir}/questions-section-1.png`),
            section2: UrlService.getLocalImageUrl(`${imgDir}/questions-section-2.png`),
            section4: UrlService.getLocalImageUrl(`${imgDir}/questions-section-4.png`),
            section5: UrlService.getLocalImageUrl(`${imgDir}/questions-section-5.png`),
            section6: UrlService.getLocalImageUrl(`${imgDir}/questions-section-6.png`),
        },
    },
    seo: {
        title: '黃金亮眼行動',
        description: '黃金亮眼行動',
        ogImage: UrlService.getLocalImageUrl(`${imgDir}/hero.png`),
        url: `https://finddoc.com/${href}`,
        shouldTitleSkipFindDocPostfix: true,
    },
    nav: {
        image: `${imgDir}/hero.png`,
        external: {
            selftest: 'https://www.loveeyesight.hk/%E6%84%9B%E8%A6%96%E5%8A%9B%E6%B8%AC%E8%A9%A6'
        },
        data: [
            { id: 'home', name: '主頁', href: `/${href}`, hiddenInNav: false },
            { id: 'introduction', name: '亮眼同行', href: `/${href}/introduction` },
            { id: 'content', name: '亮眼百科', href: `/${href}/content`, hiddenInNav: false },
            { id: 'activity', name: '亮眼活動', href: `/${href}/activity`, hiddenInNav: false },
            { id: 'sponsor', name: '亮眼同行資助計劃', href: `/${href}/sponsor` },
            // { id: 'about-us', name: '關於我們', href: `/${href}/about-us`, hiddenInNav: false },
        ],
    },
    menuBarData: {
        introduction: [
            { id: 'introduction', name: '介紹', href: `/${href}/introduction` },
            { id: 'cure', name: '治療', href: `/${href}/introduction/cure` },
            { id: 'questions', name: '常見問題', href: `/${href}/introduction/questions` },
        ],
        content: [
            { id: 'all', name: '全部', href: '#all' },
            // { id: 'cure', name: '開心大派對 - 好視自然來', href: '#cure' },
            { id: 'vision', name: '好視自然來', href: '#vision' },
            { id: 'life', name: '護眼同盟', href: '#life' },
            // { id: 'suggestion', name: '醫生的話', href: '#suggestion' },
            // { id: 'hkapes', name: '香港私人眼科醫生協會（HKAPES）', href: 'https://hkapes.org/index.php?route=disease' },
        ],
    },
    content: [
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-1-hero.png`),
            title: '電子奶嘴',
            content: {
                lines: [
                    '近年越來越多家長使用電子奶嘴安撫小朋友，但一不留神，便會令小朋友沉迷電子產品，甚至影響眼睛健康。',
                    '譚孟堃醫生將會為大家講解小童長期使用電子產品時，應注意的眼睛護理以及保健方法。',
                ]
            },
            description: '近年越來越多家長使用電子奶嘴安撫小朋友，但一不留神，便會令小朋友沉迷電子產品，甚至影響眼睛健康。',
            href: `/${href}/content/posts/電子奶嘴`,
            video: `https://www.youtube.com/watch?v=DAcoFTgBFow`,
            refCode: 'PP-EYL-HK-0079-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '長者眼睛問題不容忽視',
            content: {
                lines: [
                    '年紀大，眼矇並非必然！多留意家中長者的日常生活細節，提早發現他們的眼睛問題。',
                    '劉啟傑醫生將會為大家講解長者眼疾問題同埋相關護理方法。',
                ]
            },
            description: '年紀大，眼矇並非必然！多留意家中長者的日常生活細節，提早發現他們的眼睛問題。',
            href: `/${href}/content/posts/長者眼睛問題不容忽視`,
            video: `https://www.youtube.com/watch?v=gOhoxpBsrfI`,
            refCode: 'PP-EYL-HK-0072-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '黃斑病變是什麼',
            content: {
                lines: [
                    '你或者屋企人有冇試過望錯number上錯巴士？電話字體越改越大？唔好睇小日常生活細節！',
                    '呢啲可能係黃斑部病變嘅初期症狀。如果唔及早知道眼睛有問題，會影響往後嘅日常生活！',
                ]
            },
            description: '你或者屋企人有冇試過望錯number上錯巴士？電話字體越改越大？唔好睇小日常生活細節！',
            href: `/${href}/content/posts/黃斑病變是什麼`,
            video: `https://www.youtube.com/watch?v=yx9juPAIJic`,
            refCode: 'PP-EYL-HK-0077-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '老年黃斑病變',
            content: {
                lines: [
                    '如果你有三高，又煙又酒，又年過五十，小心會有輕微的老年黃斑病變！',
                    '初期是沒有任何特徵的！大家可以透過觀察亞姆斯勒方格表，為自己檢查有沒有老年黃斑病變。',
                ]
            },
            description: '如果你有三高，又煙又酒，又年過五十，小心會有輕微的老年黃斑病變！',
            href: `/${href}/content/posts/老年黃斑病變`,
            video: `https://www.youtube.com/watch?v=_CXs90mgoTk`,
            refCode: 'PP-EYL-HK-0076-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '糖尿眼有年輕化趨勢？',
            content: {
                lines: [
                    '上班族經常捱夜，一日三餐多在外用餐，飲食習慣唔好，',
                    '普遍都唔健康，所以患上糖尿上眼都有年輕化的趨勢！',
                ]
            },
            description: '上班族經常捱夜，一日三餐多在外用餐，飲食習慣唔好，普遍都唔健康，所以患上糖尿上眼都有年輕化的趨勢！',
            href: `/${href}/content/posts/糖尿眼有年輕化趨勢？`,
            video: `https://www.youtube.com/watch?v=Nr2rcGL2gno`,
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '飲食習慣差增加糖尿上眼的風險',
            content: {
                lines: [
                    '糖尿上眼患者分享親身經歷，原來飲食唔健康可以嚴重增加糖尿上眼嘅風險！',
                    '譚秀雯醫生將會為大家講解糖尿病上眼對生活的影響。',
                ]
            },
            description: '糖尿上眼患者分享親身經歷，原來飲食唔健康可以嚴重增加糖尿上眼嘅風險！',
            href: `/${href}/content/posts/飲食習慣差增加糖尿上眼的風險`,
            video: `https://www.youtube.com/watch?v=IL7JnuTACfI`,
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '正「視」眼健康–關注糖尿眼與黃斑病',
            content: {
                lines: [
                    '關注眼睛健康嘅你要注意啦！如果突然視力模糊，睇到嘅野扭曲變形，隨時有機會係糖尿上眼，可能變盲！黃斑病變可以點預防？',
                    '講座有眼科專科醫生 葉佩珮同大家講解護眼資訊，糖尿天使創辦人Kammie亦會分享糖尿病患者控制眼疾貼士以及照顧者需要嘅注意事項。',
                ]
            },
            description: '關注眼睛健康嘅你要注意啦！如果突然視力模糊，睇到嘅野扭曲變形，隨時有機會係糖尿上眼，可能變盲！黃斑病變可以點預防？',
            href: `/${href}/content/posts/正「視」眼健康–關注糖尿眼與黃斑病`,
            video: `https://www.facebook.com/watch/?v=442244266808494`,
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '留意兒童不良用眼習慣 及早做眼科檢查',
            content: {
                lines: [
                    '近視？斜視？弱視？這些都是小朋友最常見的眼睛問題！一但視力出現問題，只要及早求醫，改善機會大大提升！',
                    '楊珍珍醫生為大家講解有關斜視、弱視、近視的問題。',
                ]
            },
            description: '近視？斜視？弱視？這些都是小朋友最常見的眼睛問題！一但視力出現問題，只要及早求醫，改善機會大大提升！',
            href: `/${href}/content/posts/留意兒童不良用眼習慣 及早做眼科檢查`,
            video: `https://www.youtube.com/watch?v=QLhIGldvwO4`,
            refCode: 'PP-EYL-HK-0079-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '上班族警惕：工作壓力引致眼睛不適',
            content: {
                lines: [
                    '上班族因長期工作壓力引致眼乾，只用眼藥水緩解不適難以根治眼部症狀，若不妥善處理有可能誘發黃斑病變等併發症狀。',
                    '駱家慶醫生將會為大家講解有關因壓力引致的眼乾問題。',
                ]
            },
            description: '上班族因長期工作壓力引致眼乾，只用眼藥水緩解不適難以根治眼部症狀，若不妥善處理有可能誘發黃斑病變等併發症狀。',
            href: `/${href}/content/posts/上班族警惕：工作壓力引致眼睛不適`,
            video: `https://www.youtube.com/watch?v=ud3JwCsIb0s`,
            refCode: 'PP-EYL-HK-0072-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '糖尿上眼引致的眼疾',
            content: {
                lines: [
                    '糖尿病作為最常見的都市病之一，糖尿病人患上白內障、青光眼、糖尿病視網膜病變等的機會比常人高，',
                    '一旦病情惡化更有機會失明。李嘉祐醫生將會為大家講解有關糖尿病影響眼睛健康的問題。',
                ]
            },
            description: '糖尿病作為最常見的都市病之一，糖尿病人患上白內障、青光眼、糖尿病視網膜病變等的機會比常人高，一旦病情惡化更有機會失明。',
            href: `/${href}/content/posts/糖尿上眼引致的眼疾`,
            video: `https://www.youtube.com/watch?v=jR7X-Q3tMj0`,
            refCode: 'PP-EYL-HK-0077-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '長者視力退化常見眼疾',
            content: {
                lines: [
                    '隨着年紀增長，長者視力退化，其中三種常見的眼疾：1. 老年黃斑病變，2. 糖尿病性視網膜病變，3. 青光眼。',
                    '姚沛良醫生將會為大家講解長者眼疾潛在的風險。',
                ]
            },
            description: '隨着年紀增長，長者視力退化，其中三種常見的眼疾：1. 老年黃斑病變，2. 糖尿病性視網膜病變，3. 青光眼。',
            href: `/${href}/content/posts/長者視力退化常見眼疾`,
            video: `https://www.youtube.com/watch?v=TzChkZMkSr8`,
            refCode: 'PP-EYL-HK-0076-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '斜視‧弱視‧近視？正視兒童眼健康！',
            content: {
                lines: [
                ]
            },
            description: '年紀大，眼矇並非必然！多留意家中長者的日常生活細節，提早發現他們的眼睛問題。',
            href: `/${href}/content/posts/斜視‧弱視‧近視？正視兒童眼健康！`,
            video: `https://www.youtube.com/watch?v=xbcCqONYI0Q`,
            refCode: 'PP-EYL-HK-0084-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '上班族眼睛要健康：小心糖尿眼同眼乾',
            content: {
                lines: [
                ]
            },
            description: '',
            href: `/${href}/content/posts/上班族眼睛要健康：小心糖尿眼同眼乾`,
            video: `https://www.youtube.com/watch?v=ADBYFbS0ASU`,
            refCode: 'PP-EYL-HK-0084-1',
            tags: [
                '護眼同盟',
            ],
        },
        {
            img: UrlService.getLocalImageUrl(`${imgDir}/post-2-hero.png`),
            title: '長者眼疾與視力退化',
            content: {
                lines: [
                ]
            },
            description: '',
            href: `/${href}/content/posts/長者眼疾與視力退化`,
            video: `https://www.youtube.com/watch?v=DLJUazyU5zI`,
            refCode: 'PP-EYL-HK-0084-1',
            tags: [
                '護眼同盟',
            ],
        },
    ].reverse(),
}
